import { useEffect } from "react";

export const SITE_URL = "https://jayalminshawi.com";

const upsert = (selector, attr, key, content) => {
  if (content == null) return;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

// Centralised per-page SEO: title, description, canonical, Open Graph, Twitter, robots.
export function useSeo({
  title,
  description,
  path = "/",
  image = "/android-chrome-512x512.png",
  type = "website",
  noindex = false,
}) {
  useEffect(() => {
    const url = SITE_URL + path;
    const img = image.startsWith("http") ? image : SITE_URL + image;
    if (title) document.title = title;
    upsert('meta[name="description"]', "name", "description", description);
    upsert('meta[property="og:title"]', "property", "og:title", title);
    upsert('meta[property="og:description"]', "property", "og:description", description);
    upsert('meta[property="og:url"]', "property", "og:url", url);
    upsert('meta[property="og:type"]', "property", "og:type", type);
    upsert('meta[property="og:image"]', "property", "og:image", img);
    upsert('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    upsert('meta[name="twitter:title"]', "name", "twitter:title", title);
    upsert('meta[name="twitter:description"]', "name", "twitter:description", description);
    upsert('meta[name="twitter:image"]', "name", "twitter:image", img);
    upsert('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(url);
  }, [title, description, path, image, type, noindex]);
}
